import {
  type BackgroundCheckCandidateResponse,
  BackgroundCheckCandidateResponseSchema,
  CreateBackgroundCheckCandidateRequestBodySchema,
} from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";
import { type AxiosError } from "axios";

const getPostBackgroundCheckCandidateUrl = (workerId: string) => {
  return `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/background-check-candidates`;
};

interface CreateBackgroundCheckCandidateRequestData {
  workerId: string;
}

export function useCreateBackgroundCheckCandidate(
  options: UseMutationOptions<
    BackgroundCheckCandidateResponse,
    AxiosError,
    CreateBackgroundCheckCandidateRequestData
  > = {}
): UseMutationResult<
  BackgroundCheckCandidateResponse,
  AxiosError,
  CreateBackgroundCheckCandidateRequestData
> {
  return useMutation({
    mutationFn: async (data: CreateBackgroundCheckCandidateRequestData) => {
      const { workerId } = data;
      const response = await post({
        url: getPostBackgroundCheckCandidateUrl(workerId),
        data: {
          data: {
            type: "background-check-candidate",
          },
        },
        requestSchema: CreateBackgroundCheckCandidateRequestBodySchema,
        responseSchema: BackgroundCheckCandidateResponseSchema,
      });
      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.POST_BACKGROUND_CHECK_CANDIDATE_FAILURE,
    },
    ...options,
  });
}
